import React, { useCallback, useEffect } from 'react';

const UpdateMap = ({ map, location }) => {
  const moveTo = useCallback(() => {
    map.flyTo(location, map.getZoom());
  }, [location, map]);

  useEffect(() => {
    moveTo();
  }, [location, map, moveTo]);

  return <></>;
};

export default UpdateMap;
